import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "../axiosConfig"; // Import global Axios instance

const Auth = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    useEffect(() => {
        const token = searchParams.get("token");

        if (!token) {
            console.error("No token found in URL");
            navigate("/login");
            return;
        }

        const verifyToken = async () => {
            try {
                const response = await axios.post("/auth/verify/", { token });
                navigate("/dashboard");
            } catch (error) {
                console.error("Login failed:", error.response?.data?.error || error.message);
                navigate("/login");
            }
        };

        verifyToken();
    }, [searchParams, navigate]);

    return <p>Authenticating...</p>;
};

export default Auth;
